<div
  [mmTestState]="isSuggestionsListVisible ? 'active' : 'history'"
  class="suggestion-list"
  fxLayout.mm-mobile="column nowrap"
  fxLayout="row wrap">

  <ng-container *ngIf="isSuggestionsListVisible
      && (!searchQuery || searchQuery.length === 0)
      && historyTerms && historyTerms.length > 0">
    <app-generic-suggestion-item
      *ngFor="let item of historyTerms | slice: 0 : itemsToShow; even as even"
      [mmTestId]="'BUYER_PAGES.SUGGESTION_ITEM'"
      fxFlex="100"
      fxFlex.mm-mobile="0 0 auto"
      fxLayout="row wrap"
      fxLayoutAlign="flex-start center"
      (historyRemoved)="historyRemoved.emit($event)"
      (termSelected)="termSelected.emit($event)"
      [isHistory]="true"
      [suggestion]="item">
    </app-generic-suggestion-item>
  </ng-container>


  <ng-container *ngIf="isSuggestionsListVisible
      && searchQuery && searchQuery.length > 0
      && suggestions && suggestions.length > 0">
    <a
      *ngIf="suggestionsProducts && suggestionsProducts.length > 0"
      class="products-divider"
      (click)="promoClick.emit(true)"
      [routerLink]="searchRoute"
      [queryParams]="{ 'q': searchQuery, 'f.promotion': true }">
      <span [innerHTML]="'HEADER.ALL_PAGES.HEADER.SUGGESTIONS.TO_PROMO' | translate"></span>
      <mm-icon class="arrow-right" name="arrow-right-ico"></mm-icon>
    </a>
    <app-generic-suggestion-item
      *ngFor="let suggestion of suggestions | slice: 0 : itemsToShow; even as even"
      [mmTestId]="'BUYER_PAGES.SUGGESTION_ITEM'"
      fxFlex="100"
      fxFlex.mm-mobile="0 0 auto"
      fxLayout="row wrap"
      fxLayoutAlign="flex-start center"
      (termSelected)="termSelected.emit($event)"
      [suggestion]="suggestion"
      [searchQuery]="searchQuery">
    </app-generic-suggestion-item>
  </ng-container>
</div>
